import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ProcessMocnWork request (FormData for file upload)
export const ProcessMocnWorkRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessMocnWork`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Generate Regeneration-Based Audit (new approach comparing with regenerated scripts)
export const GenerateRegenerationAuditRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/GenerateAuditSummary`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Run Ericsson Audit request (FormData for file upload)
export const RunEricssonAuditRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/RunEricssonAudit`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Generate enodebPairing request
export const ProcessEnodebPairingWorkRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessEnodebPairingWork`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Alarms Diff request (ZIP containing pre + post CSV files)
export const ProcessAlarmsDiffRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessAlarmsDiff`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Run Nokia Description Checks (no input needed)
export const RunNokiaDescriptionChecksRequest = () => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/RunNokiaDescriptionChecks`
	});
};

// Nokia Description Diff - compare Excel scripts against what's in MRBTSDESC.groupName
export const RunNokiaDescriptionDiffRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/RunNokiaDescriptionDiff`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};
